// extracted by mini-css-extract-plugin
export default {"body1":"body1--UwXhf","body1-text-link":"body1-text-link--zP0ju"};